module.exports = __webpack_public_path__ + "static/img/i41.8c06356.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/i41.png
// module id = vShL
// module chunks = 3